























































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<I.TempEmployee, State>;
type DataStore = U.DataStore<I.TempEmployee>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  listUser: I.MealUserSearchData[];

  constructor() {
    this.listUser = [];
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getUserInfo() {
    const search = this.dataItem.search;
    const result = await this.API.call.temp.tempEmployeeSearch(search);
    console.log(result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '사원',
      store: new DataStore<I.TempEmployee>({
        headers: {
          empno: '사원번호',
          name: '성명',
          companyName: '회사',
          deptNameA: '사업장',
          deptNameB: '부서',
          dutyNameA: '직급'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 820;
  height = 390;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler));

@Component
export default class AxRelayPortDialog extends Mixins(BaseData, Handlers) {
  onDialogChanged() {
    this.param.callback();
  }

  async onDialogRowClicked(item: I.MealUserSearchData) {
    const confirm = await this.showConfirmModal(
      '확인',
      `성명: ${item.name}, 사원번호 : ${item.empno}<br /><br />선택한 항목이 맞습니까?`
    );
    if (confirm !== 0) return;
    this.param.selected = [item];
    this.param.callback();
    this.on = false;
  }

  async onSearchEvent() {
    this.param.headers = this.dataItem.store.headers;
    const userInfo = await this.getUserInfo();

    if (userInfo) {
      console.log(userInfo);
      this.param.items = userInfo;
    }
  }
}
